import AdminLayout from '@/components/admin/AdminLayout';

export default function Subscribers() {
  return (
    <AdminLayout>
      <div className="eyebrow">Subscribers · Phase 1</div>
      <h1 className="h-title">Subscriber Console</h1>
      <p className="lead" style={{ marginBottom: 32 }}>
        Active subscribers, tier overrides, lifetime value, and quote history. Wires real data in
        Sprint 5 once the customer-facing portal is live.
      </p>
      <div className="empty-state" style={{ background: 'var(--bg-1)', border: '1px dashed var(--line-2)', padding: 60 }}>
        <div style={{ fontFamily: 'var(--display)', fontSize: 28, color: 'var(--text-dim)' }}>Coming in Sprint 5</div>
        <p>Subscriber list pulls from <code style={{ fontFamily: 'var(--mono)', color: 'var(--gold)' }}>/users</code> with active subscriptions, joined to quote counts and MRR.</p>
      </div>
    </AdminLayout>
  );
}
